export class PatientModel{
    "studyId":Number;
    "userId":Number;
    "siteId":Number;
}